// battery-scenario.js
import { updateDateData } from './dateControls.js';

const STORAGE_KEY = 'batteryScenario';
const scenarioSelect = document.getElementById('battery-scenario');
const canvas = document.getElementById('battery-day-chart');

if (scenarioSelect !== null && canvas !== null) {
  // Restore a previously chosen scenario from localStorage, if valid.
  const storedScenario = window.localStorage.getItem(STORAGE_KEY);
  const isValidOption = [...scenarioSelect.options].some(o => o.value === storedScenario);
  if (storedScenario !== null && isValidOption) {
    scenarioSelect.value = storedScenario;
  }

  // Sync the canvas to whatever is actually selected right now. Required even on a
  // fresh page load, since the template always renders data-chart with a hardcoded
  // default (10kwh) regardless of what the <select> ends up showing.
  canvas.setAttribute('data-chart', 'battery-day.php?scenario=' + scenarioSelect.value);

  scenarioSelect.addEventListener('change', () => {
    window.localStorage.setItem(STORAGE_KEY, scenarioSelect.value);
    canvas.setAttribute('data-chart', 'battery-day.php?scenario=' + scenarioSelect.value);
    updateDateData('date-change');
  });
}
